module.exports = __webpack_public_path__ + "img/logo-TNC.e1515390.svg";